/* CaseKaro — Switch Model v2.2 (9 Oct 2026; v1 prototype 23 Sep)
   Shows "Switch model" under the title on design product pages. The shopper picks
   another phone and lands on the SAME design for that phone, keeping their finish
   (glass stays glass, hard stays hard). If that finish isn't made for the new phone,
   the sheet says so and offers the finishes that ARE available (with prices) — the
   shopper chooses; nothing changes finish silently. The wanted finish is remembered
   for the visit (sessionStorage ck_switch_want) so a later switch restores it.
   Works off SKUs (TYPE-BATCH-MODEL-DESIGN), not handles, because handles are not
   uniform (e.g. "asus-zenfone-5z-abstract-printed-cover-0291").
   Never writes the shopper's saved model (ck_iphone_model_v2 / ck_match).
   Sets sessionStorage ck_switched=1 before navigating so the Model Pop stays quiet.

   ── v2.0 — "their phone" ─────────────────────────────────────────────
   Catalogue-card clicks land on whatever phone Meta showed. About 4 in 10 card
   buyers buy for a different phone than the page they landed on. v2 uses the
   phone we already know to remove the search step:
     1. ONE TAP. On a page made for another phone, a button under the title:
        "Get this design for <their phone>". It appears only after we have found
        that product (same design, same finish), so it never leads to a dead end.
        If their finish isn't made for their phone, the tap opens the sheet on the
        "available in" choice instead.
     2. PINNED. The sheet lists their phone first, under "Your phone".
     3. MODEL POP TILE. window.__ckSwitch.mineFor(entry) returns this design for
        the phone the Model Pop detected; ck-device-popup.js ≥ 2.6.0 shows it as
        the first tile of "Made for your phone". One resolver for both surfaces.
     4. CART STAMP. After a switch, the next product page sets cart attribute
        ck_switch = mine | pinned | pick | pop, so orders show which path they
        came through (same mechanism as ck_played_game).
   Their phone = remembered iPhone (ck_iphone_model_v2, iOS only), else this
   visit's match (ck_match), else the Android model code in the user agent — the
   same sources the Model Pop and the finder pages use. Read only.

   ── v2.1 ─────────────────────────────────────────────────────────────
   window.__ckSwitch.isFor(entry): is this page already for that phone, by SKU
   model code. The Model Pop (v2.7+) uses it so it stays quiet on the
   visitor's own phone whatever the product handle looks like.

   ── v2.2 ─────────────────────────────────────────────────────────────
   The model file now comes from the same versioned URL the Model Pop reads
   (the data-map on its script tag in theme.liquid). Before, this file built
   an unversioned URL; browsers keep that for a year, so returning visitors
   never saw phones added after their first visit, and the page downloaded
   the file twice. The model file and this product's .js go through
   window.__ckGet: one fetch per URL per page, shared with ck-device-popup.js
   (v2.7.1+). models() copies iPhone entries instead of writing into the
   shared data. */
(function () {
  if (!/\/products\//.test(location.pathname) || window.__ckSwitch) return;
  window.__ckSwitch = { stage: "init", v: "2.2" };
  var S = window.__ckSwitch;
  var SKU_RE = /^(CK|GC|TP|BS|MC)-(\d{3,4})-([A-Za-z0-9]+)-(\d{3,4})$/i;
  var POP = ["iPhone 17", "iPhone 16", "iPhone 15", "Samsung S24 Ultra", "Samsung A35 5G", "Samsung A17 5G",
    "OnePlus Nord 5", "OnePlus Nord CE5", "Nothing Phone 3a Pro", "Nothing Phone 2A", "iQOO Neo 10", "Vivo V60e 5G",
    "Google Pixel 9", "Samsung S24 FE 5G", "Poco X6 Neo", "CMF by Nothing Phone 2 Pro"];
  var FIN = { GC: "Glass", CK: "Hard", BS: "Black Soft", TP: "Soft", MC: "Metal" };
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  function norm(s) { return String(s || "").toLowerCase().replace(/[^a-z0-9]/g, ""); }
  function track(ev, o) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, o)); } catch (e) {} }
  function jget(u, ms) {
    return Promise.race([
      fetch(u, { credentials: "same-origin" }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }),
      new Promise(function (r) { setTimeout(function () { r(null); }, ms || 4000); })
    ]);
  }
  // One fetch per URL per page, shared with ck-device-popup.js (same helper there).
  // Parsed JSON or null; never rejects; a failed URL may be fetched again later.
  function ckGet(u) {
    var c = window.__ckGet || (window.__ckGet = {});
    if (!c[u]) c[u] = fetch(u, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (j) { if (j == null) delete c[u]; return j; });
    return c[u];
  }
  function sget(u, ms) {
    return Promise.race([ckGet(u), new Promise(function (r) { setTimeout(function () { r(null); }, ms || 4000); })]);
  }
  // Model file: the Model Pop's data-map URL (versioned by asset_url, so a nightly rewrite
  // reaches returning visitors). Fallback without it: the unversioned sibling of this file.
  function dataUrl() {
    try {
      var pop = document.querySelector('script[data-map*="ck-popup-data"]');
      if (pop && pop.getAttribute("data-map")) return pop.getAttribute("data-map");
      var me = document.querySelector('script[src*="Ck-switch-model"]');
      if (me && me.src) return me.src.split("?")[0].replace(/Ck-switch-model\.js$/i, "ck-popup-data.json");
    } catch (e) {}
    return null;
  }
  function cacheGet(k) { try { var o = JSON.parse(localStorage.getItem("ck_switch_mk_v1") || "{}"); return o[k]; } catch (e) { return null; } }
  function cacheSet(k, v) { try { var o = JSON.parse(localStorage.getItem("ck_switch_mk_v1") || "{}"); o[k] = v; localStorage.setItem("ck_switch_mk_v1", JSON.stringify(o)); } catch (e) {} }

  // S.ready resolves true once the switcher is built on a design page, false otherwise.
  var readyRes; S.ready = new Promise(function (r) { readyRes = r; });
  var _byName = {};

  // ── 0. Cart stamp for a switch made on the previous page ────
  var USED_KEY = "ck_sw_used";
  (function stamp() {
    var k = null;
    try { k = sessionStorage.getItem(USED_KEY); if (k) sessionStorage.removeItem(USED_KEY); } catch (e) {}
    if (!k || window.__ckSwitchNoNav) return;
    S.stamped = k;
    try {
      fetch("/cart/update.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { ck_switch: k } }) }).catch(function () {});
    } catch (e) {}
    track("ck_switch_landed", { ck_kind: k });
  })();
  function mark(kind) { try { sessionStorage.setItem(USED_KEY, kind); } catch (e) {} }

  // ── 1. What is this page? ──────────────────────────────────
  // On phones the model file is fetched alongside the product (the Model Pop loads the
  // same file anyway); on desktop only once we know this is a design page, as in v1.
  var path = location.pathname.replace(/\/$/, ""), DATA_URL = dataUrl();
  // Same URL string the Model Pop builds for this product, so the two share one fetch.
  var hm = location.pathname.toLowerCase().match(/\/products\/([^\/?#]+)/);
  var PROD_URL = hm ? "/products/" + hm[1] + ".js" : path + ".js";
  function data() { return DATA_URL ? sget(DATA_URL, 6000) : Promise.resolve(null); }
  var early = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ? data() : null;
  sget(PROD_URL).then(function (p) {
    if (!p || !p.variants || /finder/i.test(p.type || "")) return readyRes(false);
    S.p = p;
    if (!readCur()) return readyRes(false);           // accessories etc. → no button
    S.stage = "page";
    return (early || data()).then(function (d) { build(d, p); });
  }).catch(function () { readyRes(false); });

  // Selected variant is re-read at click time: the shopper may have changed finish
  // (Hard → Glass) on this page after it loaded; the theme updates ?variant= in the URL.
  function readCur() {
    var p = S.p, vid = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
    var v = p.variants.filter(function (x) { return String(x.id) === vid; })[0] || p.variants[0];
    var m = String(v.sku || "").match(SKU_RE);
    if (!m) return null;
    S.cur = { type: m[1].toUpperCase(), bm: m[2] + "-" + m[3], design: m[4], title: p.title, solo: p.variants.length === 1 };
    return S.cur;
  }

  // Wanted finish. Kept only while the shopper is still on the page the switcher sent
  // them to, with the finish they picked from the "not available" buttons. If they
  // change finish on the page, or browse elsewhere, their current finish is the intent.
  var WANT_KEY = "ck_switch_want";
  function wanted() {
    var w = null;
    try { w = JSON.parse(sessionStorage.getItem(WANT_KEY) || "null"); } catch (e) {}
    if (w && w.path === location.pathname && w.type === S.cur.type) return w.want;
    try { sessionStorage.removeItem(WANT_KEY); } catch (e) {}
    return S.cur.type;
  }
  function go(url, want, landedType, kind) {
    try {
      sessionStorage.setItem("ck_switched", "1");
      if (want && landedType && want !== landedType)
        sessionStorage.setItem(WANT_KEY, JSON.stringify({ want: want, type: landedType, path: url.split("?")[0] }));
      else sessionStorage.removeItem(WANT_KEY);
    } catch (e) {}
    if (kind) mark(kind);
    S.went = url;
    if (!window.__ckSwitchNoNav) location.href = url;
  }

  // ── 2. Model list (same file the Model Pop uses) ──────────
  function models(d) {
    var out = [], seen = {};
    function add(e) { if (e && e.n && e.h && !seen[e.n]) { seen[e.n] = 1; out.push(e); } }
    var ip = (d && d.iphone) || {}, map = ip.map || {};
    (ip.order || []).forEach(function (n) { var e = map[String(n).toLowerCase()]; if (e) add(e.n ? e : Object.assign({}, e, { n: n })); });
    var ipc = out.length, a = (d && d.android) || {};
    for (var k in a) add(a[k]);
    out.ipc = ipc;
    return out;
  }
  function currentModel(list, title) {
    var t = norm(title.replace(/\s+(glass case|back cover|back covers|case|cover)$/i, "")), best = null;
    list.forEach(function (e) { var n = norm(e.n); if (n && t.slice(-n.length) === n && (!best || n.length > norm(best.n).length)) best = e; });
    return best;
  }

  // ── 2b. Their phone ────────────────────────────────────────
  function hwModel() {
    var ua = navigator.userAgent, m = ua.match(/; ([^;]+) Build\//) || ua.match(/\(([^;]+);/), raw = m && m[1] ? m[1].trim() : null;
    return new Promise(function (res) {
      var done = false;
      function fin(v) { if (!done) { done = true; res(v); } }
      setTimeout(function () { fin(raw); }, 700);
      try {
        if (navigator.userAgentData && navigator.userAgentData.getHighEntropyValues)
          navigator.userAgentData.getHighEntropyValues(["model"]).then(function (u) { fin((u && u.model) || raw); }, function () { fin(raw); });
        else fin(raw);
      } catch (e) { fin(raw); }
    });
  }
  function detectMine(d) {
    function pick(e, src) { var x = e && e.n ? _byName[norm(e.n)] : null; return x ? { e: x, src: src } : null; }
    var r = null;
    if (isIOS) {
      try {
        var raw = localStorage.getItem("ck_iphone_model_v2");
        if (raw) { var o = JSON.parse(raw); if (o && o.exp > Date.now() && o.m) r = pick(o.m, "saved"); }
      } catch (e) {}
    }
    if (!r) { try { var c = sessionStorage.getItem("ck_match"); if (c) r = pick(JSON.parse(c), "visit"); } catch (e) {} }
    if (r) return Promise.resolve(r);
    if (!/Android/i.test(navigator.userAgent)) return Promise.resolve(null);
    return hwModel().then(function (hw) {
      var e = hw && d && d.android ? d.android[String(hw).toLowerCase()] : null;
      return pick(e, "device");
    });
  }

  // ── 3. UI ──────────────────────────────────────────────────
  function css() {
    var s = document.createElement("style");
    s.textContent =
      ".cksw-row{display:flex;align-items:center;gap:8px;margin:8px 0 4px;font-size:13px;line-height:1.3;font-family:inherit}" +
      ".cksw-for{color:#6b7280}.cksw-for b{color:#111827;font-weight:700}" +
      ".cksw-btn,.cksw-x,.cksw-mine{-webkit-tap-highlight-color:transparent;user-select:none;-webkit-user-select:none;box-sizing:border-box}" +
      ".cksw-row .cksw-btn{display:inline-flex;align-items:center;gap:5px;padding:6px 11px;border:1.5px solid #6C5CE7;border-radius:999px;background:#fff;color:#6C5CE7;font-family:inherit;font-size:12.5px;font-weight:700;cursor:pointer;min-height:0;box-shadow:none;text-transform:none;letter-spacing:0}" +
      ".cksw-btn svg{width:14px;height:14px}" +
      ".cksw-mine{display:flex;align-items:center;gap:10px;width:100%;margin:6px 0 10px;padding:12px 14px;border-radius:12px;background:#6C5CE7;color:#fff;font-family:inherit;font-size:14.5px;font-weight:700;line-height:1.25;text-align:left;cursor:pointer;animation:cksw-in .25s ease-out}" +
      ".cksw-mine svg{flex:none;width:18px;height:18px}.cksw-mine span{flex:1;min-width:0}.cksw-mine i{font-style:normal;font-size:20px;line-height:1;opacity:.85}" +
      ".cksw-mine:active{opacity:.9}.cksw-mine.busy{opacity:.6;pointer-events:none}" +
      ".cksw-ov{position:fixed;inset:0;z-index:2147483000;background:rgba(17,24,39,.45);display:flex;align-items:flex-end;justify-content:center;opacity:0;transition:opacity .18s}" +
      ".cksw-ov.on{opacity:1}" +
      ".cksw-sh{width:100%;max-width:520px;height:82vh;background:#fff;border-radius:18px 18px 0 0;display:flex;flex-direction:column;transform:translateY(24px);transition:transform .2s;font-family:inherit}" +
      ".cksw-ov.on .cksw-sh{transform:none}" +
      ".cksw-hd{padding:14px 16px 10px;border-bottom:1px solid #f1f1f1}" +
      ".cksw-grab{width:38px;height:4px;border-radius:4px;background:#e5e7eb;margin:0 auto 12px}" +
      ".cksw-t{display:flex;justify-content:space-between;align-items:center;font-weight:700;font-size:16px;color:#111827}" +
      ".cksw-sh .cksw-x{display:flex;align-items:center;justify-content:center;background:#f3f4f6;width:32px;height:32px;min-width:0;padding:0;border-radius:50%;font:400 20px/1 system-ui,sans-serif;color:#374151;cursor:pointer}" +
      ".cksw-sub{font-size:12.5px;color:#6b7280;margin:3px 0 10px}" +
      ".cksw-q{font-family:inherit;width:100%;box-sizing:border-box;padding:12px 14px;font-size:15px;border:1.5px solid #e5e7eb;border-radius:12px;outline:none}" +
      ".cksw-q:focus{border-color:#6C5CE7;box-shadow:0 0 0 3px rgba(108,92,231,.12)}" +
      ".cksw-bd{flex:1;min-height:0;overflow:auto;padding:4px 16px 18px;-webkit-overflow-scrolling:touch}" +
      ".cksw-l{font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:#9ca3af;font-weight:700;margin:14px 0 6px}" +
      ".cksw-i{display:flex;justify-content:space-between;align-items:center;padding:13px 2px;border-bottom:1px solid #f3f4f6;font-size:14.5px;color:#111827;cursor:pointer}" +
      ".cksw-i:active{background:#f7f5ff}.cksw-i span{color:#c4c4c4}" +
      ".cksw-i.cur{color:#9ca3af;cursor:default}.cksw-i.cur span{color:#6C5CE7;font-size:12px;font-weight:700}" +
      ".cksw-i.mine{font-weight:700}.cksw-i.mine span{color:#6C5CE7}" +
      ".cksw-none{padding:18px 2px;color:#6b7280;font-size:14px}" +
      ".cksw-busy{padding:40px 16px 48px;text-align:center;color:#374151;font-size:14.5px}" +
      ".cksw-spin{width:26px;height:26px;border:3px solid #ede9fe;border-top-color:#6C5CE7;border-radius:50%;margin:0 auto 12px;animation:cksw 0.8s linear infinite}" +
      ".cksw-na{padding:34px 12px 20px;text-align:center}.cksw-na b{display:block;font-size:15.5px;color:#111827;margin-bottom:6px}.cksw-na p{margin:0 0 18px;font-size:13.5px;color:#6b7280}" +
      ".cksw-na .cksw-back{display:inline-block;padding:10px 18px;border:1.5px solid #6C5CE7;border-radius:999px;color:#6C5CE7;font-weight:700;font-size:13.5px;cursor:pointer;user-select:none;-webkit-user-select:none}" +
      ".cksw-opts{display:flex;flex-direction:column;gap:10px;margin:4px 0 18px}" +
      ".cksw-opt{display:flex;justify-content:space-between;align-items:center;padding:14px 16px;border:1.5px solid #e5e7eb;border-radius:12px;font-size:15px;font-weight:700;color:#111827;cursor:pointer;user-select:none;-webkit-user-select:none}" +
      ".cksw-opt:active{border-color:#6C5CE7;background:#f7f5ff}.cksw-opt span{color:#6C5CE7}" +
      ".cksw-na .cksw-link{font-size:13px;color:#6b7280;text-decoration:underline;cursor:pointer}" +
      "@keyframes cksw{to{transform:rotate(360deg)}}@keyframes cksw-in{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}";
    document.head.appendChild(s);
  }

  var PHONE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="2" width="12" height="20" rx="2.5"/><line x1="10" y1="18.5" x2="14" y2="18.5"/></svg>';

  function build(d, p) {
    var list = models(d);
    if (!list.length) { S.stage = "nodata"; readyRes(false); return; }
    list.forEach(function (e) { _byName[norm(e.n)] = e; });
    var cur = currentModel(list, p.title);
    S.curModel = cur && cur.n;
    var design = cur ? p.title.slice(0, p.title.toLowerCase().lastIndexOf(cur.n.toLowerCase())).trim() : p.title.replace(/\s+(glass case|back cover)$/i, "");
    S.designName = design;
    css();

    var h1 = document.querySelector("h1.m5") || document.querySelector("main h1") || document.querySelector("h1");
    if (!h1) { readyRes(false); return; }
    var anchor = h1.closest("header") || h1;
    var row = document.createElement("div");
    row.className = "cksw-row";
    row.innerHTML = (cur ? '<span class="cksw-for">For <b></b></span>' : "") +
      '<span role="button" tabindex="0" class="cksw-btn"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M7 7h11l-3-3M17 17H6l3 3"/></svg>' +
      (cur ? "Switch model" : "Choose another phone") + "</span>";
    if (cur) row.querySelector("b").textContent = cur.n;
    anchor.parentNode.insertBefore(row, anchor.nextSibling);
    var btn = row.querySelector(".cksw-btn");
    btn.addEventListener("click", function () { open(list, cur, design); });
    btn.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(list, cur, design); } });
    S.stage = "ready";
    track("ck_switch_view", { ck_from: S.curModel || "", ck_design: S.cur.design });
    readyRes(true);

    // Their phone → one-tap button (only when this page is for another phone and the
    // same design exists for theirs). Same-phone check is by SKU model key, so it holds
    // even when the title doesn't name the model in the data file's spelling.
    detectMine(d).then(function (m) {
      if (!m) { S.mine = null; return; }
      S.mine = m.e.n; S.mineSrc = m.src;
      if (cur && m.e === cur) { S.mineSame = true; return; }
      return modelKey(m.e).then(function (bm) {
        if (!bm) { S.mineResult = "nokey"; return; }
        if (bm === S.cur.bm) { S.mineSame = true; return; }
        S.mineEnt = m.e;
        return resolveFor(m.e).then(function (r) {
          S.mineResult = r.kind;
          if (r.kind !== "na") mineButton(row, m.e, r, list, cur, design);
        });
      });
    }).catch(function () {});
  }

  function mineButton(row, ent, r, list, cur, design) {
    var b = document.createElement("div");
    b.className = "cksw-mine"; b.setAttribute("role", "button"); b.tabIndex = 0;
    b.innerHTML = PHONE_SVG + "<span></span><i>›</i>";
    b.querySelector("span").textContent = "Get this design for " + ent.n;
    row.parentNode.insertBefore(b, row.nextSibling);
    S.mineShown = true;
    track("ck_switch_mine_view", { ck_from: S.curModel || "", ck_to: ent.n, ck_design: S.cur.design, ck_src: S.mineSrc, ck_result: r.kind });
    function tap() {
      if (b.classList.contains("busy")) return;
      var t0 = S.cur.type; readCur();
      track("ck_switch_mine_tap", { ck_from: S.curModel || "", ck_to: ent.n, ck_design: S.cur.design, ck_src: S.mineSrc });
      b.classList.add("busy");
      var p = S.cur.type === t0 ? Promise.resolve(r) : resolveFor(ent);
      p.then(function (rr) {
        b.classList.remove("busy");
        r = rr;
        if (rr.kind === "direct") { go(rr.url, rr.want, rr.want, "mine"); return; }
        open(list, cur, design, { ent: ent, r: rr, kind: "mine" });
      });
    }
    b.addEventListener("click", tap);
    b.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); tap(); } });
  }

  function open(list, cur, design, preset) {
    readCur();
    track("ck_switch_open", { ck_from: S.curModel || "", ck_design: S.cur.design, ck_preset: preset ? 1 : 0 });
    var byName = _byName;
    var mine = S.mineEnt && S.mineEnt !== cur ? S.mineEnt : null;   // pinned row
    function popular() {
      if (isIOS) return list.slice(0, list.ipc);
      var out = []; POP.forEach(function (n) { var e = byName[norm(n)]; if (e && out.indexOf(e) < 0) out.push(e); });
      return out;
    }
    var popLabel = isIOS ? "iPhone models" : "Popular models";
    var ov = document.createElement("div");
    ov.className = "cksw-ov";
    ov.innerHTML = '<div class="cksw-sh" role="dialog" aria-label="Switch phone model"><div class="cksw-hd"><div class="cksw-grab"></div>' +
      '<div class="cksw-t"><span>Get this design for</span><span role="button" tabindex="0" class="cksw-x" aria-label="Close">×</span></div>' +
      '<div class="cksw-sub"></div><input class="cksw-q" type="search" placeholder="Search your phone model…" autocomplete="off"></div>' +
      '<div class="cksw-bd"></div></div>';
    ov.querySelector(".cksw-sub").textContent = design;
    document.body.appendChild(ov);
    var html = document.documentElement, prevOv = html.style.overflow; html.style.overflow = "hidden";
    var sh = ov.querySelector(".cksw-sh"), vv = window.visualViewport;
    // Keep the sheet inside the VISIBLE area: when the keyboard opens, the visual
    // viewport shrinks, so the overlay follows it and the sheet sits above the keyboard.
    // The sheet has a fixed height, so it never shrinks/jumps when results change.
    function fit() {
      var h = vv ? vv.height : window.innerHeight, top = vv ? vv.offsetTop : 0;
      ov.style.top = top + "px"; ov.style.bottom = "auto"; ov.style.height = h + "px";
      sh.style.height = Math.min(h - 10, Math.round(window.innerHeight * 0.82)) + "px";
    }
    fit();
    if (vv) { vv.addEventListener("resize", fit); vv.addEventListener("scroll", fit); }
    requestAnimationFrame(function () { ov.classList.add("on"); });
    var bd = ov.querySelector(".cksw-bd"), q = ov.querySelector(".cksw-q");
    function close() {
      if (vv) { vv.removeEventListener("resize", fit); vv.removeEventListener("scroll", fit); }
      ov.classList.remove("on"); html.style.overflow = prevOv; setTimeout(function () { ov.remove(); }, 200);
    }
    ov.addEventListener("click", function (e) { if (e.target === ov) close(); });
    ov.querySelector(".cksw-x").addEventListener("click", close);

    var shown = [], pinned = null;
    // pin → their phone first, under "Your phone" (default list only, not search results)
    function render(items, label, pin) {
      pinned = pin || null;
      shown = (pin ? [pin].concat(items.filter(function (e) { return e !== pin; })) : items).slice(0, pin ? 61 : 60);
      if (!shown.length) { bd.innerHTML = '<div class="cksw-none">No match — try a shorter name, e.g. “S24” or “Nord”.</div>'; return; }
      bd.innerHTML = shown.map(function (e, i) {
        var isCur = cur && e === cur, isPin = pin && i === 0;
        return (isPin ? '<div class="cksw-l cksw-lp">Your phone</div>' : "") + (i === (pin ? 1 : 0) ? '<div class="cksw-l cksw-lm"></div>' : "") +
          '<div class="cksw-i' + (isCur ? " cur" : "") + (isPin ? " mine" : "") + '" data-i="' + i + '"><em style="font-style:normal"></em><span>' + (isCur ? "Current" : "›") + "</span></div>";
      }).join("");
      var lm = bd.querySelector(".cksw-lm"); if (lm) lm.textContent = label;
      var rows = bd.querySelectorAll(".cksw-i"); for (var i = 0; i < rows.length; i++) rows[i].querySelector("em").textContent = shown[i].n;
    }
    function home() { render(popular(), popLabel, mine); }
    home();
    q.addEventListener("input", function () {
      var v = q.value.trim().toLowerCase().replace(/[^a-z0-9 ]/g, "");
      if (!v) { home(); return; }
      var parts = v.split(/\s+/);
      render(list.filter(function (e) { var n = e.n.toLowerCase().replace(/[^a-z0-9 ]/g, ""); return parts.every(function (w) { return n.indexOf(w) > -1; }); }), "Results");
    });

    // Result of a pick: go straight there, or show the finishes that do exist.
    function result(ent, r, kind, ms) {
      S.last = r; S.ms = ms || 0;
      track("ck_switch_pick", { ck_from: S.curModel || "", ck_to: ent.n, ck_design: S.cur.design, ck_want: r.want, ck_result: r.kind, ck_ms: S.ms, ck_kind: kind });
      function back() { q.disabled = false; q.value = ""; home(); }
      if (r.kind === "direct") { go(r.url, r.want, r.want, kind); return; }
      var na = document.createElement("div"); na.className = "cksw-na";
      if (r.kind === "choose") {
        na.innerHTML = '<b></b><p>Available in this design:</p><div class="cksw-opts"></div><span class="cksw-link" role="button" tabindex="0">Choose another phone</span>';
        na.querySelector("b").textContent = FIN[r.want] + " case not available for " + ent.n;
        var box = na.querySelector(".cksw-opts");
        r.opts.forEach(function (o) {
          var b = document.createElement("div"); b.className = "cksw-opt"; b.setAttribute("role", "button"); b.tabIndex = 0;
          b.innerHTML = "<em style=\"font-style:normal\"></em><span></span>";
          b.firstChild.textContent = FIN[o.type]; b.lastChild.textContent = o.price ? "₹" + o.price : "›";
          b.addEventListener("click", function () {
            track("ck_switch_finish", { ck_to: ent.n, ck_design: S.cur.design, ck_want: r.want, ck_pick: o.type, ck_kind: kind });
            b.style.opacity = ".5"; go(o.url, r.want, o.type, kind);
          });
          box.appendChild(b);
        });
        na.querySelector(".cksw-link").addEventListener("click", back);
      } else {
        na.innerHTML = '<b></b><p>Try another phone.</p><span class="cksw-back" role="button" tabindex="0">Choose another phone</span>';
        na.querySelector("b").textContent = "Not available for " + ent.n;
        na.querySelector(".cksw-back").addEventListener("click", back);
      }
      q.disabled = true;
      bd.innerHTML = ""; bd.appendChild(na);
    }

    bd.addEventListener("click", function (e) {
      var it = e.target.closest(".cksw-i"); if (!it || it.classList.contains("cur")) return;
      var ent = shown[+it.getAttribute("data-i")]; if (!ent) return;
      var kind = pinned && ent === pinned ? "pinned" : "pick";
      var busy = document.createElement("div"); busy.className = "cksw-busy";
      busy.innerHTML = '<div class="cksw-spin"></div><div></div>';
      busy.lastChild.textContent = "Finding " + design + " for " + ent.n + "…";
      bd.innerHTML = ""; bd.appendChild(busy); q.disabled = true;
      var t0 = Date.now();
      resolveFor(ent).then(function (r) { result(ent, r, kind, Date.now() - t0); });
    });

    if (preset) result(preset.ent, preset.r, preset.kind);
  }

  // ── 4. Resolve: same design, chosen model ─────────────────
  function modelKey(ent) {
    var c = cacheGet(ent.h); if (c) return Promise.resolve(c);
    var hs = [ent.h, ent.gh].filter(Boolean), i = 0;
    function next() {
      if (i >= hs.length) return Promise.resolve(null);
      return jget("/collections/" + hs[i++] + "/products.json?limit=3").then(function (j) {
        var ps = (j && j.products) || [];
        for (var a = 0; a < ps.length; a++) for (var b = 0; b < ps[a].variants.length; b++) {
          var m = String(ps[a].variants[b].sku || "").match(SKU_RE);
          if (m) { var k = m[2] + "-" + m[3]; cacheSet(ent.h, k); return k; }
        }
        return next();
      });
    }
    return next();
  }
  function img(v, p, w) {
    var u = (v && v.featured_image && v.featured_image.src) || p.featured_image || "";
    if (!u) return "";
    if (u.indexOf("//") === 0) u = "https:" + u;
    return u + (u.indexOf("?") === -1 ? "?" : "&") + "width=" + (w || 360);
  }
  function findSku(sku, preferSolo) {
    var u = "/search/suggest.json?q=" + encodeURIComponent(sku) + "&resources[type]=product&resources[limit]=4&resources[options][fields]=variants.sku";
    return jget(u).then(function (j) {
      var hs = (((j || {}).resources || {}).results || {}).products || [];
      return Promise.all(hs.slice(0, 4).map(function (x) { return jget("/products/" + x.handle + ".js"); }));
    }).then(function (ps) {
      var hits = [];
      (ps || []).forEach(function (p) {
        if (!p || !p.variants) return;
        p.variants.forEach(function (v) {
          if (String(v.sku || "").toUpperCase() === sku.toUpperCase() && v.available) hits.push({ p: p, v: v });
        });
      });
      if (!hits.length) return null;
      hits.sort(function (a, b) { return preferSolo ? a.p.variants.length - b.p.variants.length : b.p.variants.length - a.p.variants.length; });
      var h = hits[0], cmp = h.v.compare_at_price && h.v.compare_at_price > h.v.price ? Math.round(h.v.compare_at_price / 100) : 0;
      return { url: "/products/" + h.p.handle + "?variant=" + h.v.id, handle: h.p.handle, price: Math.round(h.v.price / 100), cmp: cmp,
        title: h.p.title, img: img(h.v, h.p) };
    });
  }
  // want available → go straight. Otherwise check every other finish in parallel and
  // return the ones that exist (with prices) for the shopper to choose.
  var ORDER = ["GC", "CK", "BS", "MC", "TP"];   // Soft last: 2-3% of demand
  function resolve(ent) {
    var cur = S.cur, want = wanted();
    return modelKey(ent).then(function (bm) {
      if (!bm) return { kind: "na", want: want };
      function probe(t) {
        var preferSolo = t === "GC" && (cur.type !== "GC" || cur.solo);   // standalone glass listing first
        return findSku(t + "-" + bm + "-" + cur.design, preferSolo);
      }
      return probe(want).then(function (hit) {
        if (hit) return { kind: "direct", want: want, url: hit.url, hit: hit };
        var others = ORDER.filter(function (t) { return t !== want; });
        return Promise.all(others.map(probe)).then(function (hits) {
          var opts = [];
          hits.forEach(function (h, k) { if (h) opts.push({ type: others[k], url: h.url, price: h.price, hit: h }); });
          return opts.length ? { kind: "choose", want: want, opts: opts } : { kind: "na", want: want };
        });
      });
    });
  }
  // One lookup per phone and finish per page view, shared by the button, the sheet
  // and the Model Pop. A failed lookup is not kept, so the sheet can retry it.
  var _res = {};
  function resolveFor(ent) {
    var key = norm(ent.n) + "|" + wanted();
    if (!_res[key]) _res[key] = resolve(ent).then(function (r) {
      if (r.kind === "na") delete _res[key];
      return r;
    }, function () { delete _res[key]; return { kind: "na", want: S.cur.type }; });
    return _res[key];
  }

  // ── 5. For the Model Pop: this design for the phone it detected ──
  // Returns { url, handle, title, img, price, cmp } (prices as "₹129") or null.
  // Prefers the shopper's finish; if their phone doesn't have it, the first finish
  // that exists (the tile shows its own price, so nothing is hidden).
  S.mineFor = function (entry) {
    if (!entry || !entry.n) return Promise.resolve(null);
    return S.ready.then(function (ok) {
      if (!ok) return null;
      var ent = _byName[norm(entry.n)] || entry;
      if (!ent.h) return null;
      return modelKey(ent).then(function (bm) {
        if (!bm || bm === S.cur.bm) return null;               // their own phone's page
        return resolveFor(ent).then(function (r) {
          var h = r.kind === "direct" ? r.hit : (r.kind === "choose" && r.opts.length ? r.opts[0].hit : null);
          if (!h) return null;
          return { url: h.url, handle: h.handle, title: h.title, img: h.img, price: h.price ? "₹" + h.price : "", cmp: h.cmp ? "₹" + h.cmp : "" };
        });
      });
    }).catch(function () { return null; });
  };

  // ── 6. For the Model Pop (v2.7+): is this page already for that phone? ──
  // By SKU model code, so it holds for any handle. true / false, or null when
  // this isn't a design page or the model's code can't be found.
  S.isFor = function (entry) {
    if (!entry || !entry.n) return Promise.resolve(null);
    return S.ready.then(function (ok) {
      if (!ok) return null;
      var ent = _byName[norm(entry.n)] || entry;
      if (!ent.h) return null;
      return modelKey(ent).then(function (bm) { return bm ? bm === S.cur.bm : null; });
    }).catch(function () { return null; });
  };
})();
